import { render, staticRenderFns } from "./AddStartingPoint.vue?vue&type=template&id=4dc6df88&"
import script from "./AddStartingPoint.vue?vue&type=script&lang=js&"
export * from "./AddStartingPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports